@if (pollId && userToken) {
    <app-poll-view [pollId]="pollId" [userToken]="userToken"
                   class="pollembedContainer"></app-poll-view>
}
